var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 15.637A3.367 3.367 0 0115.637 19H8.363A3.367 3.367 0 015 15.637V8.363A3.367 3.367 0 018.363 5h7.274A3.367 3.367 0 0119 8.363v7.274zm-7.156-.37a3.426 3.426 0 003.423-3.423 3.426 3.426 0 00-3.423-3.422 3.426 3.426 0 00-3.422 3.422 3.426 3.426 0 003.422 3.423zm4.181-8.264a.895.895 0 000 1.789.895.895 0 000-1.79z"
  })));
}

export default SvgIconInstagram;